/** Pure helpers for whether Rules UI may claim native app blocking is live. */

import type { RulesCapability } from "../rules/ruleTypes";

/** Schedule says a rule is active, but native may still be permission-gated. */
export function canClaimNativeAppEnforcement(
  appBlocking: RulesCapability | null | undefined,
  options: { isNativePlatform: boolean },
): boolean {
  if (!options.isNativePlatform) return true;
  if (appBlocking == null) return false;
  return appBlocking.status === "active";
}

export type AndroidAppBlockingGateReason =
  | "overlay_permission_not_granted"
  | "usage_access_not_granted"
  | null;

/** Android-only: which permission CTA to show when app blocking is gated. */
export function androidAppBlockingGateReason(
  appBlocking: RulesCapability | null | undefined,
  options: { isAndroid: boolean },
): AndroidAppBlockingGateReason {
  if (!options.isAndroid || appBlocking == null) return null;
  if (appBlocking.status !== "permission_gated") return null;
  if (appBlocking.reason === "usage_access_not_granted") return "usage_access_not_granted";
  if (appBlocking.reason === "overlay_permission_not_granted") return "overlay_permission_not_granted";
  // Prefer overlay CTA when reason is missing but still gated (legacy / partial payloads).
  return "overlay_permission_not_granted";
}
